import { includes } from "lodash";

import type { MedicalPlanPrice } from "Utils/types";

const metalTierToNumberHash = {
  bronze: 0,
  silver: 1,
  gold: 2,
  platinum: 3,
};

export const planMetalTierToNumber = (plan: MedicalPlanPrice): number => metalTierToNumberHash[plan.metal_tier];

export function isMinimalPlan(plan) {
  return includes(["mec", "mvp"], plan.target_market);
}
